import memberServiceClient from "./client"
import { Response } from "../Model"
import { MyInfoData } from "../../myInfo/myInfo"
import { ApplicationError } from "../applicationError"

const getMyInfoCallback = (code: string, state: string) => {
    return memberServiceClient.get<Response<MyInfoData> | Response<ApplicationError>>(
        `myinfo/auth/callback/web`,
        {
            params: {
                code: code,
                state: state,
                callbackUrl: window.myNtucConfig.myInfoCallbackUrl, // myinfo only allows with this URL for dev. purposes
            },
        },
    )
}

const getPLSMyInfoCallback = (code: string) => {
    return memberServiceClient.get<Response<MyInfoData> | Response<ApplicationError>>(
        `myinfo/pls-auth/callback/web`,
        {
            params: {
                code: code,
            },
        },
    )
}

const getPLSMyInfoURL = () => {
    return memberServiceClient.get<string>(
        `myinfo/pls-auth/web`,
    )
}

export default getMyInfoCallback
export { getPLSMyInfoURL, getPLSMyInfoCallback }